import { initExpand } from "../utils/expand"

export function initOfferFold() {
  initExpand(".button.-offer", ".section.-fold")
}
